import { render } from "./Navbar.vue?vue&type=template&id=513d8ddc&scoped=true"
import script from "./Navbar.vue?vue&type=script&lang=js"
export * from "./Navbar.vue?vue&type=script&lang=js"

import "@/assets/css/navbar.css?vue&type=style&index=0&id=513d8ddc&scoped=true&lang=css"
import "./Navbar.vue?vue&type=style&index=1&id=513d8ddc&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-513d8ddc"]])

export default __exports__